import { localContentPrefix } from '../../../config';
import { FetchAggregationsQuickSearchOptions } from '../../../api/listContent/fetchAggregationsQuickSearch';
import { http } from '../../../api/axios';
import { AggregationResponseOut } from '../../../store/api';

type Params = FetchAggregationsQuickSearchOptions & {
    ageCategory?: string;
    shopLanguage: string | undefined;
};

export function fetchNewlyAddedAggregationsQuickSearch(params: Params) {
    return http
        .post<AggregationResponseOut>(
            `${localContentPrefix}/v1/marketplace/newlyadded/aggregation/quicksearch`,
            params.filters,
            {
                params: {
                    filterKey: params.filterKey,
                    quickSearchQuery: params.quickSearchQuery,
                    ageCategory: !params.ageCategory ? null : params.ageCategory,
                    shopLanguage: params.shopLanguage
                }
            }
        )
        .then(response => response.data);
}
